const HTTP = "EFFECT_HTTP";

const middleware = client => () => next => action =>
  action.type === HTTP
    ? client[action.payload.call](action.payload.data)
    : next(action);

module.exports = {
  middleware,
};



// WEBPACK FOOTER //
// ../shared/optilit-redux-middleware/http.js